import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import SarahDialogPanel from './SarahDialogPanel';

/**
 * AgentDockPanel — Agent 停靠面板（多标签容器）
 *
 * 内置标签：💬 萨拉（自由对话，SarahDialogPanel）
 * 扩展标签：其他扩展通过 app.taroAgentTabs.register() 注册
 *   （如 taro-case 的"发布案例"、"案例探讨"）
 *
 * 自动切页：
 * - 进入案例讨论页 → 自动激活"案例探讨"（若已注册且用户可见）
 * - 划词打开（app.sarahAi 外部触发）→ 自动回到"萨拉"
 */
export default class AgentDockPanel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.activeTab = 'chat';
    this._lastUrl = null;

    // 外部激活某标签：document.dispatchEvent(new CustomEvent('taro:agent-tab', {detail: {id: 'case-composer'}}))
    this._tabActivator = (e) => {
      if (e.detail && e.detail.id) {
        this.activeTab = e.detail.id;
        m.redraw();
      }
    };
    document.addEventListener('taro:agent-tab', this._tabActivator);

    // 划词等外部打开时强制回到萨拉标签
    if (!app.taroAgentTabsEvents) {
      app.taroAgentTabsEvents = {
        activateChat: () => {
          this.activeTab = 'chat';
          m.redraw();
        },
      };
    }
  }

  onremove(vnode) {
    super.onremove(vnode);
    document.removeEventListener('taro:agent-tab', this._tabActivator);
    if (this._urlWatcher) clearInterval(this._urlWatcher);
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    // SPA 路由变化时自动切换（进案例页 → 案例探讨）
    this._urlWatcher = setInterval(() => {
      const url = m.route.get();
      if (url !== this._lastUrl) {
        this._lastUrl = url;
        this.autoSwitchForRoute(url);
      }
    }, 400);
  }

  autoSwitchForRoute(url) {
    try {
      const tabs = this.visibleTabs();
      // 案例讨论页 → 激活案例探讨标签
      const chatTab = tabs.find((t) => t.id === 'case-chat');
      const disc = app.current && app.current.data && app.current.data.discussion;
      if (chatTab && disc && typeof disc.taroCase === 'function' && disc.taroCase()) {
        this.activeTab = 'case-chat';
        m.redraw();
        return;
      }
      // 离开案例页且当前标签不可见 → 回萨拉
      if (!tabs.find((t) => t.id === this.activeTab)) {
        this.activeTab = 'chat';
        m.redraw();
      }
    } catch (e) { /* noop */ }
  }

  visibleTabs() {
    const tabs = [
      { id: 'chat', label: '萨拉', icon: '💬', component: SarahDialogPanel },
    ];
    const registry = app.taroAgentTabs;
    if (registry && registry._tabs) {
      for (const t of registry._tabs) {
        try {
          if (!t.shouldShow || t.shouldShow()) {
            tabs.push(t);
          }
        } catch (e) { /* noop */ }
      }
    }
    return tabs;
  }

  view() {
    const tabs = this.visibleTabs();
    const activeId = (tabs.find((t) => t.id === this.activeTab) || tabs[0]).id;

    return (
      <div className={'AgentDock AgentDock--' + activeId}>
        {tabs.length > 1 && (
          <div className="AgentDock-tabs" role="tablist">
            {tabs.map((t) => (
              <button
                key={t.id}
                type="button"
                role="tab"
                aria-selected={t.id === activeId}
                className={'AgentDock-tab' + (t.id === activeId ? ' is-active' : '')}
                onclick={() => {
                  this.activeTab = t.id;
                  m.redraw();
                }}
              >
                <span className="AgentDock-tabIcon">{t.icon}</span>
                <span className="AgentDock-tabLabel">{t.label}</span>
              </button>
            ))}
          </div>
        )}
        <div className="AgentDock-body">
          {/* 全部标签常驻渲染（display 切换），保持萨拉会话等组件状态不丢 */}
          {tabs.map((t) => (
            <div
              key={t.id}
              className={'AgentDock-pane' + (t.id === activeId ? ' is-active' : '')}
              style={{ display: t.id === activeId ? 'flex' : 'none' }}
            >
              {t.id === 'chat' ? <SarahDialogPanel /> : <t.component />}
            </div>
          ))}
        </div>
      </div>
    );
  }
}
